import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

const cache = {};
export const useReportMeta = () => {
  const { user } = useAuth();
  const uid = user?.id;
  const [meta, setMeta] = useState(cache[uid] || null);
  useEffect(() => {
    if (!uid || cache[uid]) return;
    Promise.all([api.get("/reports/catalog"), api.get("/reports/filter-options")]).then(([c, o]) => {
      cache[uid] = { ...c.data, options: o.data };
      setMeta(cache[uid]);
    });
  }, [uid]);
  return meta;
};

export async function downloadBlob(promise, fallbackName) {
  const r = await promise;
  const cd = r.headers["content-disposition"] || "";
  const name = (cd.match(/filename="?([^"]+)"?/) || [])[1] || fallbackName;
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}

export const GROUPS = {
  registry: ["ordinance_registry", "resolution_registry", "measure_listing", "disposition"],
  session: ["sessions", "attendance_voting"],
  legislative: ["legislative_output", "disposition"],
};
